import { Edit } from "react-admin";
import * as React from "react";
import { GalleryCreateForm } from "./GalleryCreate";

export const GalleryEdit = () => (
  <Edit>
    <GalleryCreateForm />
  </Edit>
);
